import {useCallback} from "react";
import {useSearchParams} from "react-router-dom";
import {ListTypeEnum} from "../Enums/ListTypeEnum";
import {CarViewEnum} from "../Enums/CarViewEnum";

export const useCarListParameters = () => {
    const [params, setParams] = useSearchParams()

    const listType = params.get('listType') || ListTypeEnum.carzelle;
    const viewType = params.get('viewType') || CarViewEnum.list;
    const carHash = params.get('carhash') || undefined;
    const maxPrice = params.get('maxprice') ? parseInt(params.get('maxprice')) : undefined;
    const make = params.get('make') || undefined;

    const setCarListParameters = useCallback((newParams) => {
        setParams((params) => {
            if (newParams.listType !== undefined) {
                params.set('listType', newParams.listType);
            }

            if (newParams.viewType !== undefined) {
                params.set('viewType', newParams.viewType);
            }

            if (newParams.maxprice !== undefined) {
                params.set('maxprice', newParams.maxprice.toString());
            }

            if (newParams.carhash !== undefined) {
                params.set('carhash', newParams.carhash);
            }

            if (newParams.make !== undefined) {
                params.set('make', newParams.make);
            }

            return params;
        });
    }, []);

    return {listType, viewType, carHash, maxPrice, make, setCarListParameters};
}
